import { PageBlockComponent } from "./widgetCmsData";

export function mapLocalizationResponse(
  components: PageBlockComponent[],
): LocalizationConfig {
  return components.reduce(
    (acc, curr) => ({
      ...acc,
      [curr.title!]: curr.description,
    }),
    {} as LocalizationConfig,
  );
}

export interface LocalizationConfig {
  modaldescription: string;
  modalconfirmbutton: string;
  modalproceedbutton: number;
  modalmorebutton: string;
  modalhidebutton: string;
  noappmessage: string;
  downloadappbutton: string;
}
